import { Eye, EyeOff } from 'lucide-react'
import { Tooltip } from '@/components/ui/overlays'
import { cn } from '@/lib/utils'

/**
 * Who can see one note.
 *
 * Shared between the configured list on an upcoming meeting and the written
 * note on a past one, because it is the same decision at two points in time —
 * and a decision made before the meeting should not look like a different
 * control once the note exists.
 */
export function NoteVisibility({
  shared,
  onChange,
  busy,
  title,
}: {
  shared: boolean
  onChange: (shared: boolean) => void
  busy?: boolean
  title: string
}) {
  return (
    <Tooltip
      content={
        shared
          ? 'External participants can see this note'
          : 'Only your organisation can see this note'
      }
    >
      <button
        type="button"
        disabled={busy}
        aria-pressed={shared}
        aria-label={
          shared
            ? `${title}: visible to external participants. Make internal only`
            : `${title}: internal only. Make visible to external participants`
        }
        onClick={() => onChange(!shared)}
        className={cn(
          'inline-flex h-5 shrink-0 items-center gap-1 rounded-[var(--radius-xs)] px-1.5 text-2xs outline-none',
          'hover:bg-[var(--color-surface-hover)] disabled:opacity-40',
          shared ? 'text-[var(--color-fg-muted)]' : 'text-[var(--color-fg-subtle)]'
        )}
      >
        {shared ? <Eye className="size-3" /> : <EyeOff className="size-3" />}
        {shared ? 'External' : 'Internal'}
      </button>
    </Tooltip>
  )
}
